import React from 'react';
import Icon from '../../../components/AppIcon';
import { RenderComponent } from './SiteRenderer';
import { isComponentHidden, getEditorPageMenuVisual } from '../utils/defaults';
import { useOverlayMenuPull } from '../hooks/useOverlayMenuPull';

export default function EditorPageMenu({
  menu,
  sections,
  viewport,
  siteTypography,
  planeFilter,
  selected,
  onSelect,
  onOpenSettings,
  onDelete,
  site,
  onMenuLayoutChange,
}) {
  if (!menu) return null;

  const hidden = isComponentHidden(menu, viewport);
  const planeVisual = getEditorPageMenuVisual(planeFilter, { selected });
  const planeInactive = planeVisual.planeInactive;
  const overlayHero = menu.props?.overlayFirstSection === true;
  const menuFreeLayout = menu.props?.menuFreeLayout === true;
  const menuLayoutEdit =
    viewport === 'desktop' && menuFreeLayout && !planeInactive;
  const { ref: overlayPullRef, marginBottom: overlayPullMb } =
    useOverlayMenuPull(overlayHero);

  return (
    <div
      ref={overlayPullRef}
      data-page-menu
      style={{
        position: planeVisual.position,
        zIndex: planeVisual.zIndex,
        ...(planeVisual.opacity != null ? { opacity: planeVisual.opacity } : {}),
        ...(planeVisual.pointerEvents ? { pointerEvents: planeVisual.pointerEvents } : {}),
        ...(overlayPullMb != null ? { marginBottom: overlayPullMb } : {}),
      }}
      className={`sticky top-0 z-50 group/menu ${
        overlayHero ? 'border-b-0 bg-transparent' : 'border-b border-border/60 bg-inherit'
      } ${
        planeInactive ? 'wc-plane-inactive pointer-events-none' : ''
      } ${
        !planeInactive && selected
          ? 'ring-2 ring-inset ring-primary/50'
          : !planeInactive
            ? 'hover:ring-1 hover:ring-inset hover:ring-primary/20'
            : ''
      } ${hidden && !planeInactive ? 'opacity-40 outline outline-2 outline-dashed outline-muted-foreground/40' : ''}`}
      onClick={(e) => {
        if (planeInactive) return;
        if (e.target.closest('[data-menu-layout-item]')) return;
        e.stopPropagation();
        onSelect();
      }}
    >
      <div className="absolute top-2 right-2 z-20 flex items-center gap-1 opacity-0 group-hover/menu:opacity-100 transition-opacity">
        <span className="text-[10px] bg-foreground/75 backdrop-blur-sm text-background px-2.5 py-1 rounded-full font-medium">
          Menu{hidden ? ' · masqué' : ''}
          {menuLayoutEdit ? ' · glisser-déposer' : ''}
        </span>
        <button
          type="button"
          className="p-1.5 rounded-full bg-card/95 border border-border shadow-sm hover:bg-card"
          title="Paramètres menu"
          onClick={(e) => {
            e.stopPropagation();
            onOpenSettings({ kind: 'pageMenu', component: menu });
          }}
        >
          <Icon name="Settings" size={13} />
        </button>
        <button
          type="button"
          className="p-1.5 rounded-full bg-card/95 border border-border shadow-sm hover:bg-card text-destructive"
          title="Supprimer le menu"
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <Icon name="Trash2" size={13} />
        </button>
      </div>

      <RenderComponent
        comp={menu}
        sections={sections}
        interactive
        editorViewport={viewport}
        siteTypography={siteTypography}
        site={site}
        checkoutSlug={site?.slug}
        menuLayoutEdit={menuLayoutEdit}
        onMenuLayoutChange={onMenuLayoutChange}
      />
    </div>
  );
}
